module.exports = __webpack_public_path__ + "static/Sarah-2b2f7cb7b496bb7749880a8ee5b52d07.png";